import { render, staticRenderFns } from "./PricingPage.vue?vue&type=template&id=704744ce&"
import script from "./PricingPage.vue?vue&type=script&lang=js&"
export * from "./PricingPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports